import { render } from "./ModalUbicacion.vue?vue&type=template&id=6b313532"
import script from "./ModalUbicacion.vue?vue&type=script&lang=js"
export * from "./ModalUbicacion.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__